export default {
  // 알피 고객센터 위젯 로그인 연결용 신원 토큰(api-public, 응답 { status, message, data: { token } } — code 필드 없음)
  POST_IDENTITY_TOKEN: "/api/v1/alfie/identity-token",
};
